import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const DepositInvest: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      width="47"
      height="45"
      viewBox="0 0 47 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="5"
        width="40"
        height="40"
        rx="20"
        fill="#F7F7F7"
        fillOpacity="0.05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6587 19.2214C14.5409 19.7802 14.1667 20.3982 14.1667 20.8333C14.1667 21.2685 14.5409 21.8864 15.6587 22.4452C16.7267 22.9791 18.2604 23.3333 20 23.3333C21.7396 23.3333 23.2733 22.9791 24.3413 22.4452C25.4591 21.8864 25.8333 21.2685 25.8333 20.8333C25.8333 20.3982 25.4591 19.7802 24.3413 19.2214C23.2733 18.6875 21.7396 18.3333 20 18.3333C18.2604 18.3333 16.7267 18.6875 15.6587 19.2214ZM25.8333 23.5008C25.5964 23.6616 25.345 23.8068 25.0866 23.936C23.7417 24.6083 21.9421 25 20 25C18.0579 25 16.2583 24.6083 14.9134 23.936C14.655 23.8068 14.4036 23.6616 14.1667 23.5008V25C14.1667 25.4352 14.5409 26.0531 15.6587 26.6119C16.7267 27.1458 18.2604 27.5 20 27.5C21.7396 27.5 23.2733 27.1458 24.3413 26.6119C25.4591 26.0531 25.8333 25.4352 25.8333 25V23.5008ZM27.5 20.8333C27.5 19.4268 26.3817 18.3781 25.0866 17.7306C23.7417 17.0583 21.9421 16.6667 20 16.6667C18.0579 16.6667 16.2583 17.0583 14.9134 17.7306C13.6183 18.3781 12.5 19.4268 12.5 20.8333V29.1667C12.5 30.5732 13.6183 31.6219 14.9134 32.2693C16.2583 32.9417 18.0579 33.3333 20 33.3333C21.9421 33.3333 23.7417 32.9417 25.0866 32.2693C26.3817 31.6219 27.5 30.5732 27.5 29.1667V20.8333ZM25.8333 27.6675C25.5964 27.8283 25.345 27.9735 25.0866 28.1027C23.7417 28.775 21.9421 29.1667 20 29.1667C18.0579 29.1667 16.2583 28.775 14.9134 28.1027C14.655 27.9735 14.4036 27.8283 14.1667 27.6675V29.1667C14.1667 29.6018 14.5409 30.2198 15.6587 30.7786C16.7267 31.3125 18.2604 31.6667 20 31.6667C21.7396 31.6667 23.2733 31.3125 24.3413 30.7786C25.4591 30.2198 25.8333 29.6018 25.8333 29.1667V27.6675Z"
        fill="#F7F7F7"
      />
      <g filter="url(#filter0_b_275_13715)">
        <ellipse
          cx="33.3333"
          cy="13.3333"
          rx="13.3333"
          ry="13.3333"
          fill="#F7F7F7"
          fillOpacity="0.05"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.8956 14.7724C28.1939 14.474 28.6776 14.474 28.9759 14.7724L31.1094 16.9058L33.2428 14.7724C33.5412 14.474 34.0248 14.474 34.3231 14.7724C34.6215 15.0707 34.6215 15.5543 34.3231 15.8527L31.6495 18.5263C31.3512 18.8246 30.8675 18.8246 30.5692 18.5263L27.8956 15.8527C27.5973 15.5543 27.5973 15.0707 27.8956 14.7724Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1649 11.1111C33.5571 11.1111 32.9742 11.3526 32.5445 11.7823C32.1147 12.2121 31.8733 12.795 31.8733 13.4028V17.9861C31.8733 18.408 31.5313 18.75 31.1094 18.75C30.6875 18.75 30.3455 18.408 30.3455 17.9861V13.4028C30.3455 12.3898 30.7479 11.4183 31.4642 10.702C32.1805 9.98575 33.152 9.58334 34.1649 9.58334H39.5122C39.934 9.58334 40.276 9.92535 40.276 10.3472C40.276 10.7691 39.934 11.1111 39.5122 11.1111H34.1649Z"
        fill="#F7F7F7"
      />
      <defs>
        <filter
          id="filter0_b_275_13715"
          x="5"
          y="-15"
          width="56.668"
          height="56.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="7.5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_275_13715"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_275_13715"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default DepositInvest;
